import React, { useContext } from "react";
import { availApiClient } from "../apiConfig";
import { useApiTenant } from "./ApiAuthContext";

export const UserContext = React.createContext(null);

export const initialContext = {
  user: null,
  loggedIn: false,
  event: null,
};

export function UserProvider({ children }) {
  const [userData, setUserData] = React.useState(initialContext);

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
}
export const useLock = () => {
  const { tenantId } = useApiTenant();
  const { userData, setUserData } = useContext(UserContext);
  const lock = userData?.lock;
  function clearLock() {
    if (!userData?.lock?.scheduleId) {
      return Promise.resolve();
    }
    return availApiClient
      .userApiAvailabilityScheduleIdDelete(
        userData?.lock?.scheduleId,
        tenantId,
        "1.0"
      )
      .then(() => {
        setUserData({ ...userData, ...{ lock: null } });
      })
      .catch((err) => console.log(err));
  }
  return { lock, clearLock };
};

export const useUser = function useUser() {
  const { userData } = useContext(UserContext);
  return userData;
};

export const useSetUser = function useSetUser() {
  const { setUserData } = useContext(UserContext);
  return setUserData;
};

export const GroupsContext = React.createContext(null);

export function GroupsProvider({ children }) {
  const [eventsTree, setEventsTree] = React.useState();

  return (
    <GroupsContext.Provider value={{ eventsTree, setEventsTree }}>
      {children}
    </GroupsContext.Provider>
  );
}

export const useGroups = function useGroups() {
  const { eventsTree } = useContext(GroupsContext);
  return eventsTree;
};

export const useSetGroups = function useGroups() {
  const { setEventsTree } = useContext(GroupsContext);
  return setEventsTree;
};
